import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './axiosConfig';
import { initGlobalErrorNotifier } from './utils/telegramNotifier';
import { APP_NAME } from './utils/constant';

// Browser tab title comes from the common brand name
document.title = APP_NAME;

initGlobalErrorNotifier();

// Global safeguard to prevent "NotFoundError: Failed to execute 'removeChild' on 'Node'"
// and "insertBefore" errors caused by Google Translate, browser extensions, or external DOM mutations
if (typeof window !== "undefined" && typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (console && console.warn) {
        console.warn(
          "Node.removeChild safeguard: Child node is not a child of this node.",
          child,
          this
        );
      }
      if (child.parentNode) {
        return child.parentNode.removeChild(child);
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console && console.warn) {
        console.warn(
          "Node.insertBefore safeguard: Reference node is not a child of this node.",
          referenceNode,
          this
        );
      }
      if (referenceNode.parentNode) {
        return referenceNode.parentNode.insertBefore(newNode, referenceNode);
      }
      return originalInsertBefore.call(this, newNode, null);
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);